
define('jst!people_picker/_wrapper',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<div class="people-picker-wrapper <%= enablePeoplePicker ? \'\' : \'people-finder-disabled\' %>">\n  \n  <div class="bd">\n    <input type="text" class="hidden" />\n  </div>\n\n  <div class="image-block">\n    <% if(enablePeoplePicker) { %>\n      <div class="img-ext">\n        <a class="button-new secondary baby-button activate-people-finder">\n          <%=t(\'Address book #addressbook\')%>\n        </a>\n      </div>\n    <% } %>\n  </div>\n</div>\n');
 });

